import { Injectable } from '@angular/core';
import { init, captureException, configureScope, User, BrowserOptions, captureMessage, Severity, withScope, Event } from '@sentry/browser';

@Injectable()
export class SentryService {

    constructor() {/**/ }

    /**
     * Inicia o sentry.
     * @param key Chave do sentry.
     */
    public init(key: string): void {
        init({ dsn: key });
    }

    /**
     * Inicia o sentry.
     * @param options opções de inicializações do sentry.
     */
    public initWithOptions(options: BrowserOptions): void {
        init(options);
    }

    /**
     * Envia um erro customizado para o Sentry.
     * @param error Objeto de erro.
     */
    public send(error: Error) {
        captureException(error);
    }

    /**
     * Envia um log customizado para o Sentry.
     *
     * @param {SentryEvent} event
     * @memberof SentryService
     */
    public sendEvent(event: Event) {
        withScope((scope) => {
            const { message, tags, user, extra, level } = event;
            if (tags) scope.setTags(tags);
            if (user) scope.setUser(user);
            if (extra) scope.setExtras(extra);
            captureMessage(message, (level || Severity.Log));
        });
    }

    /**
     * Seta um usuário no scopo.
     * @param userEmail Email do usuário.
     * @param cpfCnpj CpfCnpj do usuário.
     * @param userID ID do usuário.
     */
    public setUser(userEmail: string, cpfCnpj: string = null, userID: number | string = null) {
        configureScope((scope) => {
            const userObject: User = { email: userEmail };
            if (userID) {
                userObject.id = String(userID);
            }
            if (cpfCnpj) {
                scope.setTag('cpfCnpj', cpfCnpj);
            }
            scope.setUser(userObject);
        });
    }

    /**
     * Retira o usuário do escopo.
     */
    public unsetUser() {
        configureScope((scope) => {
            scope.setUser(null);
        });
    }

    /**
     * Seta algumas informações para a plataforma.
     * @param version Versão do front do HUB.
     * @param machine Maquina que o usuário utilizou ao acessar o hub.
     */
    public setPlatformVersion(version: string, machine: string) {
        configureScope((scope) => {
            scope.setTag('platform_version', version);
            scope.setTag('machine', machine);
        });
    }

    /**
     * Cria uma tag customizada para um erro.
     * @param key Chave da tag.
     * @param value Valor da tag.
     */
    public setCustomTag(key: string, value: string) {
        configureScope((scope) => {
            scope.setTag('platform_version', key);
            scope.setTag('machine', value);
        });
    }

}
